/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CancelPrescriptionDialog.vue?vue&type=template&id=2a78ee86"
import script from "./CancelPrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./CancelPrescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a78ee86')) {
      api.createRecord('2a78ee86', component.options)
    } else {
      api.reload('2a78ee86', component.options)
    }
    module.hot.accept("./CancelPrescriptionDialog.vue?vue&type=template&id=2a78ee86", function () {
      api.rerender('2a78ee86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/CancelPrescriptionDialog.vue"
export default component.exports